import pick from 'lodash.pick';
import {getValidPackagesParams} from '@utils/getValidPackagesParams';
import {selectIsLast30DaysFilter} from '@components/appSlice';
import {
    fetchTransactions,
    setOptions
} from './transactionsSlice';
import {
    DEFAULT_TRANSACTIONS_OPTIONS
} from '../../../constants';

export default function ssrFetch({
    store, headers, baseUrl, params, timeout
}) {
    if (params && params.query) {
        const transactionsPerPage = store.getState().user?.user?.data?.transactionsPerPage;
        const to = params.to || transactionsPerPage || DEFAULT_TRANSACTIONS_OPTIONS.to;
        const newOptions = {
            ...DEFAULT_TRANSACTIONS_OPTIONS,
            ...getValidPackagesParams({
                ...params, to
            })
        };
        const filteredNewOptions = pick(newOptions, [
            'from',
            'to',
            'sort',
            'dir',
            'query',
            'search',
            'predefined',
            'updatedSinceDays'
        ]);
        if (!filteredNewOptions.updatedSinceDays && selectIsLast30DaysFilter(store.getState())) {
            filteredNewOptions.updatedSinceDays = 30;
        }
        store.dispatch(setOptions(filteredNewOptions));
    }
    const options = timeout ? {timeout} : {};
    return store.dispatch(fetchTransactions({headers, baseUrl, options}));
}
